import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { AuthContext } from "../App";
import Dashboard from "../components/Dashboard";
import Analisar from "../components/features/Analisar";
import Cliente from "../components/features/Cliente";
import Consultar from "../components/features/Consultar";
import Kpi from "../components/features/Kpi";
import Listarcontainer from "../components/features/Listarcontainer";
import MissingDirectory from "../components/features/MissingDirectory";
import Monitoracao from "../components/features/Monitoracao";
import Reanalise from "../components/features/Reanalise";
import Site from "../components/features/Site";
import SituacaoUpload from "../components/features/SituacaoUpload";
import Trocasenha from "../components/features/Trocasenha";
import Usuario from "../components/features/Usuario";
import Login from "../components/Login";
import ProtectedRoute from "./ProtectedRoute";

//import { renderEditInputCell } from '@material-ui/data-grid';

let defaultComponent = Dashboard;

export default function Rotas() {
    const { state: authState } = React.useContext(AuthContext);

    switch (authState.url) {
        case "/":
            defaultComponent = Dashboard;
            break;
        case "/analisar":
            defaultComponent = Analisar;
            break;
        case "/monitoracao":
            defaultComponent = Monitoracao;
            break;
        default:
            defaultComponent = Trocasenha;
            break;
    }

    return (
        <Router>
            <Switch>
                <ProtectedRoute exact path="/" component={defaultComponent} />
                <ProtectedRoute exact path="/monitoracao" component={Monitoracao} />
                <ProtectedRoute exact path="/usuario" component={Usuario} />
                <ProtectedRoute exact path="/trocasenha" component={Trocasenha} />
                <ProtectedRoute
                    exact
                    path="/listarcontainer"
                    component={Listarcontainer}
                />
                <ProtectedRoute
                    exact
                    path="/situacaoupload"
                    component={SituacaoUpload}
                />
                <ProtectedRoute
                    exact
                    path="/missingdirectory"
                    component={MissingDirectory}
                />

                <ProtectedRoute exact path="/consultar" component={Consultar} />
                <ProtectedRoute exact path="/analisar" component={Analisar} />
                <ProtectedRoute exact path="/site" component={Site} />
                <ProtectedRoute exact path="/reanalise" component={Reanalise} />
                <ProtectedRoute exact path="/kpi" component={Kpi} />
                <ProtectedRoute exact path="/cliente" component={Cliente} />
                <Route path="/" component={Login} />
                <Route path="*" component={Login} />
            </Switch>
        </Router>
    );
}
